<template>
  <main class="sterilizare-view flex">
    <div class="flex-auto">
      <h1 cy="page-title">
        Lista instrumente
      </h1>

      <div class="search-bar flex">
        <label class="relative">
          <input type="text"
                 cy="search"
                 placeholder="caută instrument"
                 @input="handleSearch" />
          <i class="absolute">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.6039 23.5514L13.7327 14.6803C13.0244 15.2838 12.2098 15.7508 11.2889 16.0814C10.3681 16.4119 9.44255 16.5772 8.51227 16.5772C6.24372 16.5772 4.32366 15.7919 2.75211 14.2213C1.18055 12.6507 0.394775 10.7311 0.394775 8.46253C0.394775 6.19397 1.17961 4.27344 2.74927 2.70094C4.31894 1.12844 6.23805 0.341248 8.50661 0.339359C10.7752 0.33747 12.6962 1.12325 14.2696 2.69669C15.8431 4.27014 16.6298 6.19066 16.6298 8.45827C16.6298 9.44239 16.4555 10.3949 16.107 11.3157C15.7585 12.2365 15.3005 13.0242 14.7329 13.6787L23.604 22.5484L22.6039 23.5514ZM8.51369 15.1591C10.3931 15.1591 11.9798 14.5122 13.2737 13.2183C14.5676 11.9244 15.2145 10.3372 15.2145 8.45686C15.2145 6.57647 14.5676 4.9898 13.2737 3.69686C11.9798 2.40391 10.3931 1.75697 8.51369 1.75603C6.63425 1.75508 5.04711 2.40203 3.75228 3.69686C2.45744 4.99169 1.8105 6.57836 1.81144 8.45686C1.81239 10.3354 2.45933 11.922 3.75228 13.2169C5.04522 14.5117 6.63189 15.1586 8.51227 15.1577" fill="black"/>
            </svg>
          </i>
        </label>

        <button cy="add-instrument-btn"
                class="bg-transparent noborder pointer"
                @click="handleAddInstrument">
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 0C11.4046 0.0496922 7.4909 1.69868 4.59479 4.59479C1.69868 7.4909 0.0496922 11.4046 0 15.5C0.0496922 19.5954 1.69868 23.5091 4.59479 26.4052C7.4909 29.3013 11.4046 30.9503 15.5 31C19.5954 30.9503 23.5091 29.3013 26.4052 26.4052C29.3013 23.5091 30.9503 19.5954 31 15.5C30.9503 11.4046 29.3013 7.4909 26.4052 4.59479C23.5091 1.69868 19.5954 0.0496922 15.5 0ZM24.3571 16.6071H16.6071V24.3571H14.3929V16.6071H6.64286V14.3929H14.3929V6.64286H16.6071V14.3929H24.3571V16.6071Z" fill="#1EB386"/>
          </svg>
        </button>
      </div>

      <div class="flex list-area">
        <div class="table-wrapper">

          <ul class="table-header flex">
            <li v-for="({ name, key }, index) in tableHeader"
                :key="key"
                :class="key">
              <span>
                {{ name }}
              </span>
            </li>
          </ul>

          <ul cy="instruments-list"
              class="table-data relative">
            <li v-for="(item, index) in instruments"
                :key="index"
                :class="{'opacity-4': selectedInstrument._id && selectedInstrument._id !== item._id}">
              <ul class="flex">
                <li v-for="({ key }, idx) in tableHeader"
                    :key="idx"
                    :class="key">
                  <span v-if="key === 'nr'">
                    <span>
                      {{ index + 1 }}
                    </span>

                    <i v-if="item.type === 'set'"
                       cy="icon-set"
                       class="icon-set absolute">
                      <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 12C7.53043 12 8.03914 11.7893 8.41421 11.4142C8.78929 11.0391 9 10.5304 9 10C9 9.46957 8.78929 8.96086 8.41421 8.58579C8.03914 8.21071 7.53043 8 7 8C6.46957 8 5.96086 8.21071 5.58579 8.58579C5.21071 8.96086 5 9.46957 5 10C5 10.5304 5.21071 11.0391 5.58579 11.4142C5.96086 11.7893 6.46957 12 7 12ZM14 10C14 10.5304 13.7893 11.0391 13.4142 11.4142C13.0391 11.7893 12.5304 12 12 12C11.4696 12 10.9609 11.7893 10.5858 11.4142C10.2107 11.0391 10 10.5304 10 10C10 9.46957 10.2107 8.96086 10.5858 8.58579C10.9609 8.21071 11.4696 8 12 8C12.5304 8 13.0391 8.21071 13.4142 8.58579C13.7893 8.96086 14 9.46957 14 10ZM17 12C17.5304 12 18.0391 11.7893 18.4142 11.4142C18.7893 11.0391 19 10.5304 19 10C19 9.46957 18.7893 8.96086 18.4142 8.58579C18.0391 8.21071 17.5304 8 17 8C16.4696 8 15.9609 8.21071 15.5858 8.58579C15.2107 8.96086 15 9.46957 15 10C15 10.5304 15.2107 11.0391 15.5858 11.4142C15.9609 11.7893 16.4696 12 17 12Z" fill="#5CB89E"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H21C21.7956 0 22.5587 0.316071 23.1213 0.87868C23.6839 1.44129 24 2.20435 24 3V17C24 17.7956 23.6839 18.5587 23.1213 19.1213C22.5587 19.6839 21.7956 20 21 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.31607 18.5587 0 17.7956 0 17L0 3ZM3 2H21C21.2652 2 21.5196 2.10536 21.7071 2.29289C21.8946 2.48043 22 2.73478 22 3V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2Z" fill="#5CB89E"/>
                      </svg>
                    </i>
                  </span>

                  <span v-else
                        cy="instrument-name"
                        class="pointer"
                        @click="handleSelectInstrumentFromTable(item)">
                    {{ item[key] }}
                  </span>
                </li>

                <li v-if="selectedInstrument._id === item._id"
                    cy="selected-instrument-options"
                    class="actions-bar right0">
                  <i class="pointer"
                     cy="sterilizare-action"
                     @click="handleSterilizationAction">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7835 5.81119L19.2813 0.946777L17.7791 5.81119L14.8728 7.19521L17.792 8.58505L19.2813 12.8411L20.7706 8.58505L23.6897 7.19521L20.7835 5.81119ZM18.846 6.73344L19.2813 5.32424L19.7166 6.73409L20.6853 7.19521L19.7295 7.65053L19.2813 8.93057L18.8331 7.65053L17.8772 7.19521L18.846 6.73344Z" fill="#1EB386"/>
                      <path d="M9.27087 7.33333L9.91671 4.75L10.5625 7.33333L12.5 7.97917L10.5625 8.625L9.91671 11.2083L9.27087 8.625L7.33337 7.97917L9.27087 7.33333Z" fill="#1EB386"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.39583 22.6722V22.8311C5.39583 23.1736 5.25975 23.5022 5.01751 23.7444C4.77528 23.9867 4.44674 24.1227 4.10417 24.1227H2.16667C1.8241 24.1227 1.49555 23.9867 1.25332 23.7444C1.01109 23.5022 0.875 23.1736 0.875 22.8311V15.7301C0.875 15.3876 1.01109 15.059 1.25332 14.8168C1.49555 14.5746 1.8241 14.4385 2.16667 14.4385H4.10417C4.39506 14.4383 4.67749 14.5364 4.9057 14.7168C5.13391 14.8972 5.29455 15.1493 5.3616 15.4324C6.21669 15.1243 7.21579 14.7575 7.52127 14.618C7.7809 14.4998 8.08056 14.4598 8.32985 14.4449C8.58713 14.4323 8.84495 14.4369 9.10163 14.4585C9.38899 14.4819 9.67516 14.5181 9.95929 14.567L9.97415 14.5696L9.97867 14.5702H9.9806L9.99223 14.5728L14.3129 15.5416L14.3393 15.5506L14.3464 15.5532L14.3761 15.5622L14.4982 15.5971C14.6048 15.6268 14.7578 15.6662 14.9406 15.7062C15.312 15.787 15.7802 15.8625 16.2161 15.8625C16.6191 15.8625 17.0363 16.013 17.2585 16.4212C17.4497 16.7712 17.4051 17.1561 17.3341 17.4222C17.2443 17.7542 17.0596 18.1029 16.8251 18.3994C17.1416 18.2799 17.4884 18.1385 17.8604 17.986L17.9399 17.9537C18.988 17.523 20.2306 17.0128 21.3272 16.8319C22.5802 16.6246 23.4914 17.0793 23.9048 17.8859C24.2729 18.6041 24.1876 19.5464 23.6335 20.1141C23.4947 20.2568 23.2828 20.4066 23.0704 20.5442C22.843 20.6921 22.5634 20.8581 22.2527 21.035C21.539 21.4345 20.8166 21.8183 20.086 22.1859C18.554 22.9628 16.9485 23.7185 16.4383 23.9051C15.8467 24.1215 15.2112 24.1421 14.6009 24.1105C14.2323 24.0876 13.8643 24.0563 13.4972 24.0168C13.2284 23.989 12.9592 23.9642 12.6899 23.9426C11.4447 23.8483 10.4889 23.5441 9.60925 23.2644L9.50204 23.2302C8.59271 22.9422 7.74667 22.6858 6.62615 22.6406C6.3704 22.6302 5.8589 22.6502 5.39583 22.6722ZM8.05667 15.7928C8.09865 15.7734 8.20844 15.7456 8.40413 15.734C8.58754 15.723 8.79679 15.7301 9.00152 15.7456C9.24645 15.7657 9.49038 15.7965 9.7326 15.838H9.73454L13.9757 16.7893L14.0048 16.7983C14.0405 16.8095 14.09 16.8238 14.1533 16.841C14.2786 16.8758 14.4556 16.9217 14.6655 16.9676C15.0433 17.0502 15.5503 17.1368 16.0656 17.1516C16.0197 17.2759 15.9581 17.3937 15.8822 17.5023C15.7789 17.6521 15.6659 17.7677 15.5729 17.8343C15.3042 18.0267 15.0872 18.1068 14.9555 18.141C14.9106 18.1534 14.8648 18.1621 14.8185 18.1669H14.8043L11.3414 18.1255L11.2187 19.4069L11.2529 19.4133L11.3517 19.4308L11.7108 19.4941C12.0124 19.547 12.4264 19.6181 12.8772 19.6917C13.7645 19.8363 14.834 19.9965 15.4411 20.0333C15.8609 20.0592 16.3492 19.93 16.8032 19.7782C17.2766 19.62 17.812 19.4011 18.3506 19.1802C19.4595 18.7255 20.5891 18.2625 21.5378 18.1055C22.358 17.9699 22.6506 18.2696 22.7552 18.4743C22.9057 18.7681 22.8243 19.0943 22.7087 19.2118C22.6809 19.2409 22.5795 19.3229 22.3677 19.4605C22.1701 19.5877 21.915 19.7408 21.6153 19.9106C20.9192 20.3003 20.2147 20.6745 19.5021 21.0331C17.9573 21.8165 16.4202 22.5353 15.994 22.6916C15.6491 22.8182 15.2222 22.8485 14.6674 22.8201C14.3406 22.8009 14.0143 22.7731 13.689 22.7368C13.3888 22.7052 13.0883 22.6776 12.7874 22.6541C11.6946 22.5715 10.8641 22.3073 9.9735 22.0244L9.89277 21.9986C8.97052 21.706 7.98369 21.4018 6.67846 21.3495C6.3846 21.3379 5.86148 21.356 5.39583 21.378V16.7919C6.30387 16.467 7.64785 15.9794 8.05667 15.7928ZM4.10417 15.7295H2.16667V22.8304H4.10417V15.7295Z" fill="#1EB386"/>
                    </svg>
                  </i>

                  <i class="pointer"
                     cy="edit-action"
                     @click="handleEditInstrument">
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3.00019L15 6.00019M10 17.0002H18M2 13.0002L1 17.0002L5 16.0002L16.586 4.41419C16.9609 4.03913 17.1716 3.53051 17.1716 3.00019C17.1716 2.46986 16.9609 1.96124 16.586 1.58619L16.414 1.41419C16.0389 1.03924 15.5303 0.828613 15 0.828613C14.4697 0.828613 13.9611 1.03924 13.586 1.41419L2 13.0002Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </i>

                  <i class="pointer"
                     cy="history-action"
                     @click="handleViewHistory">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.96201 16C5.93134 16 4.16101 15.3367 2.65101 14.01C1.14167 12.684 0.268339 11.014 0.0310059 9H1.04201C1.31401 10.72 2.09767 12.15 3.39301 13.29C4.68834 14.43 6.21134 15 7.96201 15C9.91201 15 11.566 14.321 12.924 12.963C14.282 11.605 14.9613 9.95067 14.962 8C14.9627 6.04933 14.2833 4.395 12.924 3.037C11.5647 1.679 9.91067 1 7.96201 1C6.92667 1 5.95401 1.21867 5.04401 1.656C4.13401 2.09267 3.33067 2.69433 2.63401 3.461H5.11501V4.461H0.962006V0.309H1.96201V2.697C2.73534 1.84833 3.64134 1.187 4.68001 0.713C5.71867 0.239 6.81267 0.00133333 7.96201 0C9.07067 0 10.11 0.208667 11.08 0.626C12.05 1.04333 12.8973 1.61467 13.622 2.34C14.3467 3.06533 14.918 3.91267 15.336 4.882C15.754 5.85133 15.9627 6.89067 15.962 8C15.9613 9.10933 15.7527 10.1487 15.336 11.118C14.9193 12.0873 14.348 12.9347 13.622 13.66C12.896 14.3853 12.0487 14.9567 11.08 15.374C10.1113 15.7913 9.07201 16 7.96201 16ZM11.166 11.854L7.51901 8.208V3H8.51901V7.792L11.873 11.146L11.166 11.854Z" fill="black"/>
                    </svg>
                  </i>

                  <i class="pointer"
                     cy="delete-action"
                     @click="handleDeleteInstrument">
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 7L14.16 15.398C14.033 16.671 13.97 17.307 13.68 17.788C13.4257 18.2114 13.0516 18.55 12.605 18.761C12.098 19 11.46 19 10.18 19H7.82C6.541 19 5.902 19 5.395 18.76C4.94805 18.5491 4.57361 18.2106 4.319 17.787C4.031 17.307 3.967 16.671 3.839 15.398L3 7M10.5 13.5V8.5M7.5 13.5V8.5M1.5 4.5H6.115M6.115 4.5L6.501 1.828C6.613 1.342 7.017 1 7.481 1H10.519C10.983 1 11.386 1.342 11.499 1.828L11.885 4.5M6.115 4.5H11.885M11.885 4.5H16.5" stroke="#FF5858" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </i>

                  <i class="pointer"
                     cy="close-action"
                     @click="handleResetSelectedInstrument">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 11.5L6.25 6.25L11.5 11.5M11.5 1L6.249 6.25L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </i>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div v-if="isSideFunctionality"
             class="side-functionalities-wrapper">
          <div v-if="sideFunctionalityName === 'add-instrument'"
               class="add-instrument-modal">
          </div>
        </div>
      </div>
    </div>

    <div class="side-view">
      <div v-if="sideView === 'addInstrument'">
        <AddInstrument :instruments="instruments"
                       @close="handleCloseSideModal"
                       @submit="handleSaveInstrument" />
      </div>

      <div v-if="sideView === 'editInstrument'">
        <EditInstrument :instrument="selectedInstrument"
                        :instruments="instruments.filter(o => o.type !== 'set')"
                        @close="handleCloseSideModal"
                        @submit="handleInstrumentUpdate" />
      </div>

      <div v-if="sideView === 'sterilizare'">
        <ModalSterilizareInstrument :title="selectedInstrumentTitle"
                                    @close="handleCloseSideModal"
                                    @submit="handleInstrumentSterilization" />
      </div>

      <div v-if="sideView === 'deleteInstrumentModal'">
        <DeleteDialogWindow :text="deleteDialogText"
                            @yes="handleDeleteYes"
                            @no="handleDeleteNo" />
      </div>

      <div v-if="sideView === 'history'">
        <ModalSterilizareHistory :_id="selectedInstrument._id"
                                 @close="handleCloseSideModal" />
      </div>
    </div>
  </main>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import AddInstrument from "@/components/AddInstrument.vue";
  import ModalSterilizareInstrument from "@/components/ModalSterilizareInstrument.vue";
  import EditInstrument from "@/components/EditInstrument.vue";
  import DeleteDialogWindow from "@/components/DeleteDialogWindow.vue";
  import ModalSterilizareHistory from "@/components/ModalSterilizareHistory.vue";

  export default {
    name: 'Sterilizare',
    components: { ModalSterilizareHistory, DeleteDialogWindow, EditInstrument, ModalSterilizareInstrument, AddInstrument },
    data () {
      return {
        isSideFunctionality: true,
        sideFunctionalityName: 'add-instrument',
        tableHeader: [
          {name: 'nr.', key: 'nr'},
          {name: 'nume', key: 'name'},
          {name: 'id', key: 'id'},
        ],
        selectedInstrument: {},
        deleteDialogText: `Sunteti siguri ca doriti sa stergeti “Oglinda”?`
      }
    },
    created () {
      this.$store.dispatch('get_instruments');
    },
    computed: {
      ...mapState({
        sideView: state => state.sterilizare.sideView,
      }),
      ...mapGetters(['instruments']),
      selectedInstrumentTitle () {
        return `${this.selectedInstrument.name} (${this.selectedInstrument.id})`
      }
    },
    methods: {
      handleSelectInstrumentFromTable (instrument) {
        let value = instrument;
        if (this.selectedInstrument.id) {
          value = {};
        }
        this.selectedInstrument = value;
      },
      handleSterilizationAction () {
        this.$store.commit('SET_SIDE_VIEW', 'sterilizare');
      },
      handleResetSelectedInstrument () {
        this.selectedInstrument = {};
        this.handleCloseSideModal();
      },
      handleAddInstrument () {
        this.$store.commit('SET_SIDE_VIEW', 'addInstrument');
      },
      handleEditInstrument () {
        this.$store.commit('SET_SIDE_VIEW', 'editInstrument');
      },
      handleViewHistory () {
        this.$store.commit('SET_SIDE_VIEW', 'history');
      },
      handleDeleteInstrument () {
        this.$store.commit('SET_SIDE_VIEW', 'deleteInstrumentModal');
      },
      handleSaveInstrument (data) {
        this.$store.dispatch('create_instrument', data);
      },
      handleCloseSideModal () {
        this.$store.commit('SET_SIDE_VIEW', '');
      },
      handleInstrumentSterilization (data) {
        const clbk = () => this.selectedInstrument = {};
        this.$store.dispatch('sterilyze_instrument', { ...this.selectedInstrument, ...data, clbk });
      },
      handleInstrumentUpdate (data) {
        this.$store.dispatch('update_instrument', { ...this.selectedInstrument, ...data });
        this.selectedInstrument = {};
      },
      handleDeleteYes () {
        this.$store.dispatch('delete_instrument', this.selectedInstrument._id);
        this.selectedInstrument = {};
      },
      handleDeleteNo () {
        this.$store.commit('SET_SIDE_VIEW', '');
      },
      handleSearch (ev) {
        this.$store.commit('SEARCH_INSTRUMENT', ev.target.value.toLowerCase());
      },
    }
  }
</script>

<style lang="less">
  .sterilizare-view {
    @media only screen and (min-width: 0) {
      padding: 42px 0;
      height: 100%;
      > .flex-auto {
        display: flex;
        flex-direction: column;
        min-height: 0;
      }
      .list-area {
        flex: 1;
        min-height: 0;
      }
      h1 {
        margin-bottom: 37px;
        font-size: 2.4rem;
        opacity: 0.8;
        font-weight: 300;
      }

      .search-bar {
        label {
          margin-right: 12px;
          input {
            width: 460px;
            border-radius: 4px;
            border: 1px solid #B9B9B9;
            padding-left: 12px;
          }
          i {
            opacity: 0.6;
            top: 6px;
            right: 8px;
          }
        }
      }

      .table-wrapper {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        min-height: 0;
        .table-header {
          color: #8B7474;
          font-size: 1.7rem;
        }

        .nr {
          width: 40px;
          margin-right: 24px;
          text-align: center;
        }
        .name {
          width: 360px;
        }
        .id {
          width: 72px;
          text-align: center;
        }
        .actions-bar {
          transform: translateY(-8px);
          i {
            margin-right: 12px;
          }
        }

        .table-data {
          margin-top: 4px;
          padding-top: 12px;
          border-top: 1px solid lightgrey;
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          overflow-x: hidden;
          padding-bottom: 32px;
          -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 32px), transparent 100%);
          mask-image: linear-gradient(to bottom, #000 calc(100% - 32px), transparent 100%);
          > li {
            margin-bottom: 8px;
          }
          .nr {
            opacity: 0.6;
          }
          .icon-set {
            left: 34px;
          }
        }
        li li {
          font-size: 1.8rem;
        }
        .opacity-4 {
          opacity: 0.4;
        }
      }

      .side-view {
        margin-left: 40px;
        margin-top: 60px;
        button {
          cursor: pointer;
        }
      }

      .instrument-modal-window {
        padding: 24px;
        border: 1px solid #A9A9A9;
        border-radius: 4px;
        background: linear-gradient(270deg, #F6F6F6 0%, #EDEDED 100%);
        h2 {
          margin-bottom: 24px;
          opacity: 0.6;
          font-size: 2.1rem;
          text-align: center;
        }
        form {
          width: 420px;
          label {
            display: block;
            margin-bottom: 12px;
            span {
              font-size: 1.5rem;
              margin-bottom: 4px;
            }
          }
          input {
            width: 100%;
            border-radius: 4px;
            padding-left: 8px;
          }
        }
        .actions-bar {
          margin-top: 24px;
          button {
            padding: 4px 12px;
            border: lightgray solid 1px;
            border-radius: 4px;
            font-size: 1.4rem;
            color: white;
            &:first-child {
              margin-left: auto;
              margin-right: 16px;
              background-color: #8c8c8c;
            }
            &:last-child {
              background-color: #1eb386;
            }
          }
        }
      }
    }
  }
</style>
